/** Profile fields written on sign-in — must not wipe memberships. */
export function signInUserProfilePatch(email: string): { email: string } {
  return { email: email.trim().toLowerCase() };
}
